import { render, staticRenderFns } from "./Stimul.vue?vue&type=template&id=30379057&"
import script from "./Stimul.vue?vue&type=script&lang=js&"
export * from "./Stimul.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports